<div class="hra-start-wrapper">
    <div class="header">
        <loader *ngIf="loading"
               [messageTranslationKey]="'HraProvisioningHeader'"
               [scale]="2.0">
        </loader>
    </div>
    <div [translate]="'HraProvisioningBody'" class="body"></div>
</div>
